<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="callerRolesUpdated($event)">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Students List|Students List title@@students-list-title">Students</h1>

        <div class="fill-space"></div>

        <app-button matTooltip="Import Users"
                    i18n-matTooltip="Import Users|Import Users title@@import-users-title"
                    color="primary"
                    icon="group_add"
                    [disabled]="!contest || !contestOpenForEnrol || !competitionId || !region || !school"
                    (clicked)="importStudents(competitionId || '', contest, region, school)"></app-button>

        <div class="btn-spacer"></div>

        <app-button label="Enrol Student"
                    i18n-label="Students List|Enrol Student button title@@students-list-enrol-student-button-title"
                    color="primary"
                    width="170px"
                    [disabled]="!contest || !contestOpenForEnrol || (!region && allowRegionSelect) || (!school && !allowSchoolSelect)"
                    (clicked)="enrolStudent(contest)"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <mat-spinner *ngIf="school === undefined" color="primary" diameter="30" class="center"></mat-spinner>

      <mat-accordion *ngIf="region || allowRegionSelect" class="filters-panel">
        <mat-expansion-panel [expanded]="!region || !school">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container *ngIf="region">{{region.name}}</ng-container>
              <ng-container *ngIf="!region && allowRegionSelect"
                            i18n="User Profile|School region select input label@@user-profile-school-region-select-input-label">Select Region</ng-container>
            </mat-panel-title>
            <mat-panel-description *ngIf="school">
              {{school.short_name || school.name}}
            </mat-panel-description>
            <mat-panel-description *ngIf="user && user.id && !mobileView">
              {{identifierField.value}}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <school-select *ngIf="region || allowRegionSelect"
                         [roles]="roles"
                         [selectedRegion]="region"
                         [allowRegionSelect]="allowRegionSelect"
                         [allowSchoolSelect]="allowSchoolSelect"
                         [showGrade]="false"
                         [showSchool]="allowSchoolSelect"
                         [clearSchoolAfterSelect]="false"
                         [allowSchoolClear]="true"
                         [schoolRequired]="false"
                         (regionSelected)="regionSelected($event)"
                         (schoolSelected)="schoolSelected($event)"></school-select>

          <school-details *ngIf="!allowSchoolSelect && school"
                          [school]="school"
                          [compact]="true"
                          [mobile]="mobileView"></school-details>

          <form-input [control]="identifierField"
                      label="Email or username"
                      i18n-label="Sign In|Email or username input label@@sign-in-email-or-username-label"
                      placeholder="Your email or username..."
                      i18n-placeholder="Sign In|Email or username input placeholder@@sign-in-email-or-username-placeholder"
                      autocomplete="email"
                      type="text"
                      [required]="false"
                      [minLength]="5" [maxLength]="128"
                      class="user-identifier-field"
                      [class.no-school-details]="allowSchoolSelect"
                      [suffixButton]="identifierField.value ? 'clear' : undefined"
                      [suffixAction]="clearUserSearch"
                      (keyUpEnter)="searchUser()"></form-input>
          <app-button icon="search"
                      [disabled]="!identifierField.value || !identifierField.valid"
                      (clicked)="searchUser()"></app-button>
          <mat-hint *ngIf="!inProgress && user && user.id" class="color-green">
            <mat-icon class="user-search-icon">check</mat-icon>
            <ng-container
              i18n="Invite User Modal|User found by email sub title@@invite-user-modal-user-found-by-email-sub-title"
              >User profile found</ng-container>
          </mat-hint>
          <mat-hint *ngIf="!inProgress && user && !user.id" class="color-warn">
            <mat-icon class="user-search-icon">clear</mat-icon>
            <ng-container
              i18n="Invite User|User not found by identifier title@@invite-user-user-not-found-by-identifier-title">
              User profile not found
            </ng-container>
          </mat-hint>
        </mat-expansion-panel>
      </mat-accordion>

      <contest-select-panel [competitionId]="competitionId"
                            [contest]="contest"
                            [mobileView]="mobileView"
                            (openForEnrolUpdated)="contestOpenForEnrol = $event"
                            (selected)="contestSelected($event)"></contest-select-panel>

      <app-no-content *ngIf="!inProgress && !students && region"
                      [compact]="true"
                      title="Please select a contest from the list first"
                      i18n-title="Students List|Select contest prompt@@students-list-select-contest-prompt"
                      details="Students will be loaded for the selected region and contest"
                      i18n-details="Students List|Select contest prompt detail@@students-list-select-contest-prompt-detail">
      </app-no-content>
      <app-no-content *ngIf="!inProgress && !students && !region"
                      [compact]="true"
                      title="Please select a region from the list first"
                      i18n-title="Students List|Select region prompt@@students-list-select-region-prompt"
                      details="Students will be loaded for the selected region and contest"
                      i18n-details="Students List|Select contest prompt detail@@students-list-select-contest-prompt-detail">
      </app-no-content>

      <app-no-content *ngIf="students && !students.length && (!user || !user.id) && contest && contestOpenForEnrol"
                      [compact]="true"
                      title="No students have enrolled from this school yet"
                      i18n-title="Students List|No students title@@students-list-no-students-title"
                      details="You can invite students to enroll for this contest"
                      i18n-details="Contests List|No contests details@@students-list-no-items-details">

        <app-button label="Enrol Student"
                    i18n-label="Students List|Enrol Student button title@@students-list-enrol-student-button-title"
                    color="primary"
                    width="170px"
                    class="center create-cta"
                    [disabled]="!contest || !contestOpenForEnrol || (!region && allowRegionSelect) || (!school && !allowSchoolSelect)"
                    (clicked)="enrolStudent(contest)"></app-button>
      </app-no-content>

      <app-no-content *ngIf="students && !students.length && (!user || !user.id) && contest && !contestOpenForEnrol"
                      [compact]="true"
                      title="No students have enrolled from this school yet"
                      i18n-title="Students List|No students title@@students-list-no-students-title">
      </app-no-content>

      <app-no-content *ngIf="students && !students.length && user && user.id"
                      [compact]="true"
                      title="Registration record for the selected user, region, school and contest was not found"
                      i18n-title="Students List|User not found title@@students-list-user-not-found-title"
                      details="Please change or clear some filters to get more results"
                      i18n-details="Students List|User not found details@@students-list-user-not-found-details">
      </app-no-content>

      <users-table *ngIf="competitionId && contest && students" class="users-list" #usersTable
                   [roles]="roles"
                   [users]="students"
                   [userRole]="STUDENT_ROLE"
                   [region]="region"
                   [school]="school || undefined"
                   [competitionId]="competitionId"
                   [showPayment]="true"
                   [showStatus]="true"
                   [showLocation]="allowSchoolSelect"
                   [showSchool]="allowSchoolSelect"
                   [showTeacher]="true"
                   [showGrade]="true"
                   [editAllowed]="true"
                   [selectionChoices]="selectionChoices"
                   [contest]="contest"
                   [openForEnrol]="contestOpenForEnrol"
                   [deleteAllowed]="deleteAllowed"
                   [deletePaymentCheck]="!disablePaymentCheckBeforeDelete"
                   [showUsername]="usernameAllowed"
                   [showContestProgress]="showContestProgress"
                   (usersSelectedCta)="studentsSelected($event.users, $event.model)"
                   (deleteRequested)="handleEnrolDelete($event, usersTable)"
                   (handlePaymentRetry)="paymentRetry($event.user, $event.contest)"
                   (handlePaymentVerify)="checkPaymentStatus($event.contest.id, $event.user.id, STUDENT_ROLE)"></users-table>

      <div *ngIf="inProgress" class="full-width progress-block">
        <mat-spinner  color="primary" diameter="30" class="center"></mat-spinner>
      </div>

      <div *ngIf="page && page.next_token && !inProgress" class="center-align load-more-block">
        <app-link class="load-more-link"
                  icon="arrow_downward"
                  label="load more"
                  i18n-label="Students List|Load More link label@@students-list-load-more-link-label"
                  (click)="loadNextPage()"></app-link>
      </div>
    </div>
  </div>
</permission-checker>
